// Audit Trail — PSD §8.4 (F8.4). Report screen accordion.

import type { AuditEvent } from '../../persistence/schema';

interface AuditTrailProps {
  events: AuditEvent[];
}

export function AuditTrail({ events }: AuditTrailProps) {
  if (events.length === 0) {
    return <p>No audit events recorded.</p>;
  }

  const sorted = [...events].sort((a, b) => b.timestamp.localeCompare(a.timestamp));

  return (
    <div className="table-wrap">
      <table className="data-table">
        <thead>
          <tr>
            <th>Timestamp</th>
            <th>Actor</th>
            <th>Action</th>
            <th>Source</th>
            <th>Details</th>
          </tr>
        </thead>
        <tbody>
          {sorted.map((e) => (
            <tr key={e.eventId}>
              <td className="timestamp">{e.timestamp}</td>
              <td>{e.actor}</td>
              <td>
                <code>{e.action}</code>
              </td>
              <td>{e.source}</td>
              <td className="audit-diff">
                {e.before !== null && e.after !== null && (
                  <details>
                    <summary>View change</summary>
                    <pre className="diff">
                      {JSON.stringify(e.before, null, 2)}
                      {'\n→\n'}
                      {JSON.stringify(e.after, null, 2)}
                    </pre>
                  </details>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
